import { useState, useEffect } from 'react';

// Hook personalizado para manejar el tamaño de ventana
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  });

  useEffect(() => {
    // Handler para actualizar el estado cuando cambie el tamaño
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Agregar event listener
    window.addEventListener('resize', handleResize);

    // Llamar handler inmediatamente para obtener el tamaño inicial
    handleResize();

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Funciones helper para breakpoints comunes
  const isMobile = windowSize.width <= 992;
  const isTablet = windowSize.width > 768 && windowSize.width <= 992;
  const isDesktop = windowSize.width > 992;
  const isSmallMobile = windowSize.width <= 480;
  const isVerySmallMobile = windowSize.width <= 360;

  return {
    width: windowSize.width,
    height: windowSize.height,
    isMobile,
    isTablet,
    isDesktop,
    isSmallMobile,
    isVerySmallMobile,
  };
};

export default useWindowSize;
